import React, { useState } from 'react'
import { ImReply } from 'react-icons/im'
import { RiDeleteBin6Fill } from 'react-icons/ri'
import { BsArrowReturnRight } from 'react-icons/bs'
import moment from 'moment'
import 'twin.macro'
import { useMutation, useQueryClient } from 'react-query'
import { api } from '@api/index'
import useModal from '@hooks/useModal'
import MessageModal from '@components/shared/MessageModal'
import handleEnterPress from '@utils/handleEnterPress'

interface Props {
  postUUID: number
  reply: PostReplyInfo
}

const AdminPostReply = ({ reply, postUUID }: Props) => {
  const [openResModal] = useModal()
  const queryClient = useQueryClient()
  const [isReplyMode, setIsReplyMode] = useState(false)
  const [replyContent, setReplyContent] = useState('')
  const {
    id: replyId,
    content,
    createdAt,
    author: { nickname },
    children: reReplys,
  } = reply

  const saveReplyMutation = useMutation(
    (content: string) =>
      api.adminService.createReReply(postUUID, content, replyId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['PostReply', Number(postUUID)])
        setIsReplyMode(false)
        setReplyContent('')
      },
    }
  )

  const deleteReplyMutation = useMutation(
    (replyId: number) => api.adminService.deleteReply(replyId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['PostReply', Number(postUUID)])
      },
    }
  )

  const handleReplyClick = () => {
    setIsReplyMode((prev) => !prev)
  }

  const handleChangeReplyInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setReplyContent(e.target.value)
  }

  const handleSaveReplyClick = () => {
    if (replyContent === '') return
    saveReplyMutation.mutate(replyContent, {
      onError: (err) => {
        openResModal(<MessageModal errorData={err} />)
      },
    })
  }

  const handleDeleteReplyClick = (replyId: number) => {
    deleteReplyMutation.mutate(replyId)
  }

  return (
    <>
      <div tw="flex items-center w-full gap-15 mb-10 mt-10">
        <div>{nickname}</div>
        <div>:</div>
        <div>{content}</div>
        <div tw="text-14">{`(${moment(createdAt).format(
          'YYYY-MM-DD HH:mm'
        )})`}</div>
        <button type="button" onClick={handleReplyClick}>
          <ImReply tw="text-25" />
        </button>
        <button onClick={() => handleDeleteReplyClick(replyId)} tw="ml-auto">
          <RiDeleteBin6Fill tw="text-25" />
        </button>
      </div>
      {isReplyMode && (
        <div tw="flex mt-10 w-full h-33 gap-20">
          <input
            onKeyPress={(e) => handleEnterPress(e, handleSaveReplyClick)}
            tw="w-full h-full"
            type="text"
            className="input"
            value={replyContent}
            placeholder="댓글을 입력해 주세요."
            onChange={handleChangeReplyInput}
          />
          <button
            onClick={handleSaveReplyClick}
            type="button"
            tw="w-full max-w-100 text-15 px-10 h-full"
            className="button"
          >
            댓글작성
          </button>
        </div>
      )}
      {reReplys.map(({ id, content, author: { nickname }, createdAt }) => (
        <div key={id} tw="mt-10 pl-20 flex items-center w-full gap-15">
          <BsArrowReturnRight />
          <div>{nickname}</div>
          <div>:</div>
          <div>{content}</div>
          <div tw="text-14">{`(${moment(createdAt).format(
            'YYYY-MM-DD HH:mm'
          )})`}</div>
          <button
            onClick={() => handleDeleteReplyClick(id)}
            type="button"
            tw="ml-auto"
          >
            <RiDeleteBin6Fill tw="text-25" />
          </button>
        </div>
      ))}
    </>
  )
}

export default AdminPostReply
